import React from "react";

import styles from "./style.module.css";

import { parseOffer } from "containers/Marketplace/reducer";
import { Divider, FlexSpacer } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import { Button } from "aible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default class MarketplaceDrawer extends React.PureComponent {
  render() {
    const { showDrawer, selectedItem, selectedItemType, userId, clickHandler, closeDrawer } = this.props;
    const parsedItem = parseOffer(selectedItem, userId);
    return (
      <div className={styles.drawerWrapper + (showDrawer ? " " + styles.showDrawer : "")}>
        <div className={styles.drawer}>
          <div className={styles.drawerClose}>
            <Button className={styles.drawerCloseBtn} onClick={closeDrawer}>
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
          <MarketplaceDrawerHeader type={selectedItemType} name={parsedItem.name} />
          <MarketplaceDrawerSubheader author={parsedItem.author} rating={parsedItem.rating} />
          <MarketplaceDrawerDetails description={parsedItem.description} />
          <FlexSpacer />
          <MarketplaceDrawerFooter isCreator={parsedItem.isCreator} onClick={clickHandler} />
        </div>
      </div>
    );
  }
}

class MarketplaceDrawerHeader extends React.PureComponent {
  render() {
    const { type, name } = this.props;
    const headerStyles = getStyles(type) || {};
    return (
      <div className={styles.drawerHeader + " " + headerStyles.background}>
        <h1 className={headerStyles.text}>{name}</h1>
        <div className={styles.drawerHeaderIcon}>
          <img src={headerStyles.image} alt={type} />
        </div>
      </div>
    );
  }
}

class MarketplaceDrawerSubheader extends React.PureComponent {
  render() {
    const { author } = this.props;
    return (
      <div className={styles.drawerSubheader}>
        <h1>{"by " + author}</h1>
        <Divider />
      </div>
    );
  }
}

class MarketplaceDrawerDetails extends React.PureComponent {
  render() {
    const { description } = this.props;
    return (
      <div className={styles.drawerDetails}>
        <div className={styles.drawerDescription}>{description}</div>
      </div>
    );
  }
}

class MarketplaceDrawerFooter extends React.PureComponent {
  render() {
    const { text, isCreator, onClick } = this.props;
    const buttonText = text || (isCreator ? "Remove from Marketplace" : "Add to my Aible");

    return (
      <div className={styles.drawerFooter}>
        <Divider />
        <div className={styles.footerButtons}>
          <Button className={styles.footerButton} type="secondary" onClick={() => onClick(isCreator)}>
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}
